import { render } from "./CustomerIntegrationsForm.vue?vue&type=template&id=032a43d0&scoped=true"
import script from "./CustomerIntegrationsForm.vue?vue&type=script&lang=js"
export * from "./CustomerIntegrationsForm.vue?vue&type=script&lang=js"

import "./CustomerIntegrationsForm.vue?vue&type=style&index=0&id=032a43d0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032a43d0"]])

export default __exports__